import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@mui/material';

const MONEY_PATTERN = /^\d*\.?\d{0,2}$/;
const INTEGER_PATTERN = /^\d*$/;

function toCommittedNumber(value, decimals, commitEmptyTo) {
  if (value === '' || value === null || value === undefined) {
    return commitEmptyTo;
  }
  const parsed = decimals === 0 ? parseInt(value, 10) : parseFloat(value);
  return Number.isFinite(parsed) ? parsed : commitEmptyTo;
}

export default function MoneyInput({
  value,
  onChange,
  decimals = 2,
  commitEmptyTo = 0,
  prefix = '$',
  InputProps,
  inputProps,
  onFocus,
  onBlur,
  ...rest
}) {
  const pattern = decimals === 0 ? INTEGER_PATTERN : MONEY_PATTERN;

  const handleChange = (event) => {
    const next = event.target.value.replace(/,/g, '');
    const current = String(value ?? '');
    if (next === '' || pattern.test(next) || next.length < current.length) {
      onChange(next);
    }
  };

  const handleFocus = (event) => {
    event.target.select();
    onFocus?.(event);
  };

  const handleBlur = (event) => {
    onChange(toCommittedNumber(value, decimals, commitEmptyTo));
    onBlur?.(event);
  };

  return (
    <TextField
      {...rest}
      type="text"
      value={value === null || value === undefined ? '' : String(value)}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      InputProps={{
        ...(prefix
          ? { startAdornment: <InputAdornment position="start">{prefix}</InputAdornment> }
          : {}),
        ...InputProps,
        inputProps: {
          inputMode: decimals === 0 ? 'numeric' : 'decimal',
          ...InputProps?.inputProps,
          ...inputProps,
        },
      }}
    />
  );
}

MoneyInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  decimals: PropTypes.number,
  commitEmptyTo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  prefix: PropTypes.node,
  InputProps: PropTypes.object,
  inputProps: PropTypes.object,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export function IntegerInput(props) {
  return <MoneyInput decimals={0} prefix={null} {...props} />;
}

export function toFiniteNumber(value, fallback = 0) {
  return toCommittedNumber(value, 2, fallback);
}

export function toFiniteInteger(value, fallback = 0) {
  return toCommittedNumber(value, 0, fallback);
}
